import { Rule } from "../interfaces";

/**
 * Evaluates a permission rule
 * @param rule - The rule to evaluate (boolean or predicate function)
 * @param user - User context for evaluation
 * @param data - Data context for evaluation
 * @returns true if permission is granted, false otherwise
 */
const evaluateRule = <User, Data>(rule: Rule<User, Data>, user?: User, data?: Data): boolean => {
  if (!rule) {
    // Role is not permitted to perform the provided action/permission
    // Permission not present
    return false;
  }

  if (typeof rule === "function") {
    // ABAC rule, use a predicate to determine if the user is allowed access
    return Boolean(rule(data, user));
  }

  // Rule is truthy, role has permission
  return true;
};

export default evaluateRule;
